import React from "react";
import { useNavigate } from "react-router-dom";

import { ToggleButton } from "react-bootstrap";
import ToggleSet from "./ToggleSet.jsx";
import { Stack } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { empty_uuid } from "../App/Account_urls.jsx";

import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";

export const CrumbToggle = ({
  crumb,
  set,
  current,
  onChange,
  crumbClick,
  crumbClose = null,
  prefix,
}) => {
  return (
    <>
      <Stack direction="row" spacing={2}>
        {prefix && prefix !== "" && (
          <ToggleSet set={[prefix]} current={prefix} onChange={() => { }} />
        )}
        {crumb && (
          <>
            <ToggleButton
              className="untoggled-button-active"
              sx={{ px: 5 }}
              type="radio"
              size="sm"
              checked={true}
              onClick={crumbClick}
            >
              {crumb}
            </ToggleButton>
            {crumbClose !== null && (
              // <Fab
              //   color="error"
              //   sx={{ ml: -7, mt: -7 }}
              //   style={{ transform: "scale(0.5)" }}
              //   size="small"
              // >
              <FontAwesomeIcon
                onClick={() => crumbClose()}
                size="xl"
                color="red"
                style={{
                  marginLeft: -9,
                  marginTop: -12,
                  transform: "scale(0.8)",
                }}
                icon={faCircleXmark}
              //icon="fa-solid fa-circle-xmark"
              />

              // </Fab>
            )}
          </>
        )}
        {set && (
          <ToggleSet
            key={"crumb-toggle-ts"}
            set={set}
            current={current}
            onChange={onChange}
          />
        )}
      </Stack>
    </>
  );
};

export const CrumbToggleScenario = ({
  set,
  current,
  onChange,
  crumbClose = null,
  clientJson,
  scen_name = null,
}) => {
  const navigate = useNavigate();

  const crumbClick = () => {
    navigate("/gridScenario");
  };

  return (
    <CrumbToggle
      set={set}
      current={current}
      onChange={onChange}
      crumb={scen_name !== null ? scen_name :
        clientJson === null ||
          clientJson.Scenario.uuid === undefined ||
          clientJson.Scenario.uuid === empty_uuid
          ? undefined
          : clientJson.Scenario.label
      }
      crumbClick={crumbClick}
      crumbClose={crumbClose === null ? null : () => {
        let sc = { ...clientJson.Scenario, uuid: empty_uuid, label: "" };
        let json = { ...clientJson, Scenario: sc };
        crumbClose(json);
      }}
      prefix={clientJson === null ? null :
        clientJson.public
          ? "Public"
          : clientJson.shared
            ? "Shared"
            : clientJson.readonly || clientJson.Scenario.readonly
              ? "Locked"
              : null
      }
    />
  );
};
